import { Controller } from 'react-hook-form';
import Select from '../ui/Select';
import FormSection from '../ui/FormSection';

export default function CEUCategorySelection({ 
  control, 
  errors, 
  availableCategories = [], 
  availableSubcategories = [], 
  selectedCategory,
  userProfile 
}) {
  return (
    <FormSection
      title="Category & Classification"
      description="Select the appropriate category and specific training area"
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Controller
            name="category"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                label="Category *"
                error={errors.category?.message}
                options={[
                  { value: '', label: 'Select a category' },
                  ...availableCategories.map(cat => ({
                    value: cat.value,
                    label: cat.label
                  }))
                ]}
              />
            )}
          />

          <Controller
            name="subCategory"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                label="Subcategory"
                disabled={!selectedCategory}
                options={[
                  { value: '', label: 'Select a subcategory' },
                  ...availableSubcategories.map(sub => ({
                    value: sub.value,
                    label: sub.label
                  }))
                ]}
              />
            )}
          />
        </div>
        
        {userProfile && (
          <p className="text-xs text-gray-500">
            Categories for {userProfile?.certifyingBody || 'RID'} certification
          </p>
        )}
      </div>
    </FormSection>
  );
}
